import { render } from "./TicketDetailChatBox.vue?vue&type=template&id=b2c73010"
import script from "./TicketDetailChatBox.vue?vue&type=script&lang=js"
export * from "./TicketDetailChatBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__